const accessCodeFieldStyle = theme => ({
    title: { marginRight: theme.spacing(1), marginTop: theme.spacing(1.4) },
    autoWidth: { width: 'auto' },
    labelWithIcon: { marginTop: theme.spacing(2.5) },
});

export default accessCodeFieldStyle;
